import { Expo, Linear, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import * as SFX from "../Data/SoundEffect";
import CustomBounce from "../vendor/CustomBounce";
import CultureBackground from "./CultureBackground";
export default class IndiaBackground extends CultureBackground {

    private readonly _rug: PIXI.Sprite;
    private readonly _foregroundPots: PIXI.Sprite[];
    private readonly _backgroundItems: PIXI.Sprite[];

    constructor() {
        super();
        this._rug = HLF.PixiUtils.makeSprite("background-01-00", Constants.SPRITESHEET_GAME);
        this._rug.scale = new PIXI.Point(2, 2); // HACK: this image was too big to fit in a spritesheet

        this._foregroundPots = [
            HLF.PixiUtils.makeSprite("background-01-02", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-04", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-05", Constants.SPRITESHEET_GAME),
        ];

        this._backgroundItems = [
            HLF.PixiUtils.makeSprite("background-01-01", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-03", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-06", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-07", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-08", Constants.SPRITESHEET_GAME),
            HLF.PixiUtils.makeSprite("background-01-09", Constants.SPRITESHEET_GAME),
        ];

        this.addChild(
            this._rug,
            ...this._backgroundItems,
            ...this._foregroundPots,
        );
        CustomBounce.create("customBounce-india", { strength: 0.3, squash: 0 });
    }

    /** @override */
    public AnimateOut() {
        if (this._outroTimeline !== undefined) {
            this._outroTimeline.kill();
        }
        this._outroTimeline = new TimelineMax();
        // this._outroTimeline.clear();
        this._outroTimeline
            .to(this._rug, 2, {pixi: {positionY: this._size!.y / 2, scaleX: 2.5, scaleY: 2.5}, ease: Expo.easeOut})
            .to(this._backgroundItems, 0.5, {pixi: {positionY: this._size!.y / 2, ease: Expo.easeOut}}, 0)
            .to(this._foregroundPots, 1, {pixi: {positionY: this._size!.y / 2}}, 2)
            .call(() => this._outroTimeline = undefined)

            // .play(0, false)

        ;
    }
    /** @override */
    public AnimateIn(pCallback: () => void, pDelay: number = 0): void {
        if (this._introTimeline !== undefined) {
            this._introTimeline.kill();
        }
        this._introTimeline = new TimelineMax();
        // this._introTimeline.clear();

        this._introTimeline
            .fromTo(this._rug, 2,
                {pixi: {positionY: this._size!.y, scaleX: 2.5, scaleY: 2.5}, ease: Expo.easeOut},
                {pixi: {positionY: 0, scaleX: 2, scaleY: 2}},
                pDelay,
            )
            .fromTo(this._foregroundPots, 2,
                {pixi: {positionY: this._size!.y / 2}},
                {pixi: {positionY: 0}, ease: Linear.easeIn},
                pDelay + 0.75,
            )
            .staggerFromTo(this._backgroundItems,  1,
                {pixi: {positionY: -this._size!.y / 2}},
                {pixi: { positionY: 0 }, ease: "customBounce-india"},
                0.5,
                pDelay,
                pCallback,
            )
            .call(() => this._introTimeline = undefined)
        ;

        for (let i = 0; i < this._backgroundItems.length; i++) {
            const t = pDelay + 0.75 + (0.5 * i);
            this._introTimeline.call(() => {
                Application.instance.audio.play(HLF.ArrayUtils.random(SFX.IMPACTS), 0.5, false, HLF.AudioCategory.SFX);
            }, undefined, undefined, t);
        }
    }
}
